import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// style components
import { Container, InnerContainer, Title, LoadingSpinner } from './FullScreenLoader.style'

const FullScreenLoader = ({ displayDelay = 0 }: { displayDelay?: number }) => {
    const { t } = useTranslation()
    const [isShown, setIsShown] = useState(false)

    useEffect(() => {
        const displayTimeOut = setTimeout(() => {
            setIsShown(true)
        }, displayDelay)

        return () => clearTimeout(displayTimeOut)
    }, [displayDelay])

    if (!isShown) return null

    return (
        <Container>
            <InnerContainer>
                <Title>{t('common.loadingText')}</Title>
                <LoadingSpinner />
            </InnerContainer>
        </Container>
    )
}

export default FullScreenLoader
